<template>
    <h1 v-if="!small" :class="{
          'display-1': $vuetify.breakpoint.mdAndDown,
          'display-2': !$vuetify.breakpoint.mdAndDown,
          'font-weight-bold': true,
           'text-uppercase': true,
           'text-center': true,
           'mx-auto': true,
           'my-10': true,
           }">
      {{value}}
    </h1>
  <h2
    v-else
    :class="{
          'font-weight-bold': true,
           'text-uppercase': true,
           'text-center': true,
           'mx-auto': true,
           'my-10': true,
           }"
  >
    {{value}}
  </h2>
</template>

<script>
export default {
  name: "Header",
  props:{
    value: {
      type: String,
      default: null
    },
    small: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>
